/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { useTranslate } from '@tolgee/react';
import api2DGame from '@/api/services/miniGameApi';
import { Typography } from '@/components/Atoms';
import { numberSeparator } from '@/utils/numberSeparator';
import { useStore } from '@/zustand/store/store';
import useAuthStatuses from '@/hooks/authentication/useAuthStatuses';

const MyStatsSection = () => {
  const { t } = useTranslate('commandCenter');
  const [userStats, setUserStats] = useState([]);
  const { isLogin } = useAuthStatuses();
  const {
    commandSocketData: { stateChanged },
  } = useStore();
  //@ts-ignore
  const componentArray = userStats?.map((item, index) => {
    let newData = {
      name: Object.keys(item)[0],
      value: item[Object.keys(item)[0]],
      icon: item[Object.keys(item)[1]],
    };

    return (
      <div className='w-full col-span-4 md:col-span-3 lg:col-span-3 xl:col-span-4 flex items-center gap-[6px]' key={index}>
        <div className='w-[16px] h-[16px]'>
          <Image src={newData.icon} layout='responsive' width={16} height={16} alt='icon' />
        </div>
        <div className='gap-2 flex items-center text-nowrap'>
          <Typography size='s12ToS12'>{newData.name}:</Typography>
          <Typography size='s12ToS12' className='text-[#FF9900]'>
            {numberSeparator(newData.value)}
          </Typography>
        </div>
      </div>
    );
  });

  const getData = () => {
    api2DGame.getMyStatsTwo().then((res) => {
      const newData = res.data.data_new;
      delete newData?.icon;
      setUserStats(newData);
    });
  };

  useEffect(() => {
    if (isLogin) {
      getData();
    }
  }, [isLogin]);

  useEffect(() => {
    if (stateChanged) {
      getData();
    }
  }, [stateChanged]);
  return (
    <>
      <div className='col-span-12 flex items-center'>
        <Typography size='s12ToS12' className='flex-shrink-0 font-bold'>
          {t('CENTER_SECTION.myStateSection.title')}
        </Typography>
        <div className='w-full h-[1px] bg-[#4F4F4F] mx-4'></div>
      </div>
      <div className='col-span-12 w-full grid grid-cols-10 gap-y-2'>{componentArray}</div>
    </>
  );
};

export default MyStatsSection;
